import React, { useEffect, useState } from "react";
// import Header from './../components/Header';
import { Container, Row, Col, FormGroup, Label, Input } from "reactstrap";
import ReactTooltip from "react-tooltip";
import { Modal } from "react-bootstrap";
import moment from "moment";
import {
  getAllPendingTransactions,
  searchTransactions,
} from "./../stores/services/transactions.service";
import { getFundByAmc } from "./../stores/services/funds.service";
import ViewTransaction from "./view-beta-txn";
import { toast } from "react-toastify";
import { getAllBanks } from "./../stores/services/bank.service";
import { transaction } from "mobx";
import { BsTable } from "react-icons/bs";
import { useSelector } from "react-redux";
import Select from "react-select";
import { numberWithCommas } from "../utils/customFunction";
import { newTXNType } from "../utils/ui_data";
import TransactionTable from "./TransactionListing/TransactionTable";
import ReusableModal from "./TransactionListing/TransactionView";

const PendingTransactions = ({ hasChild = "" }: { hasChild?: string }) => {
  const statusArr = [
    { label: "Created", value: "CREATED" },
    { label: "Completed", value: "COMPLETED" },
    { label: "Rejected", value: "REJECTED" },
    { label: "Rejected-Amc", value: "REJECTED-AMC" },
  ];

  const theme = useSelector((state: any) => state.ThemeModeReducer.Theme);
  const email = sessionStorage.getItem("email") || "";
  const amc_code = sessionStorage.getItem("amc_code") || "";
  const [fund_code, setFund_code] = useState(
    JSON.parse(sessionStorage.getItem("fund_code") || "[]")
  );
  let [transactions, setTransactions] = useState<any>([]);
  let [status, setStatus] = useState("");
  const [trx_history, setTrxHistory] = useState([]);
  const [viewChecklist, setViewCheckList] = useState(false);
  const [trx_checklist, setTrxCheckList] = useState([]);
  // let [lastPageNum, setLastPageNum] = useState('');
  let [paginationArr, setPaginationArr] = useState([""]);
  let [currentPage, setCurrentPage] = useState("");
  let [activePage, setActivePage] = useState("");

  const [searchLoading, setSearchLoading] = useState(false);
  const [clearLoading, setClearLoading] = useState(false);

  const [resLoading, setResLoading] = useState(false);

  const [allFunds, setAllFunds] = useState<any>([]);
  const [fund, setFund] = useState("");
  const [btnLoading, setBtnLoading] = useState(false);

  const [togglePagination, setTogglePagination] = useState(false);
  const [hasNextPage, setHasNextPage] = useState(false);

  async function getTransactions() {
    if (togglePagination != true) {
      if (activePage !== "") {
        setBtnLoading(true);
      } else {
        setResLoading(true);
      }
      await getAllPendingTransactions(
        sessionStorage.getItem("email") || "",
        status,
        searchValue,
        "",
        activePage,
        "",
        fund_code?.length > 0 ? fund_code : "",
        amc_code,
        hasChild
      )
        .then((response) => {
          if (response.data.data?.length > 0) {
            let pageArr = paginationArr;
            let existingPageIndex = paginationArr.findIndex(
              (x) => x === response.data.page_info.next_page_number
            );
            if (
              existingPageIndex === -1 &&
              response.data.data.length === 10
              // &&
              // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
            ) {
              pageArr.push(response.data.page_info.next_page_number);
            }
            setHasNextPage(response?.data?.page_info?.hasNextPage || false);
            setPaginationArr(pageArr);
            setTransactions(response.data.data);
            setTransactions([...transactions, ...response.data.data]);
            setResLoading(false);
            setBtnLoading(false);
          }
        })
        .catch((err) => {
          setHasNextPage(false);
          setResLoading(false);
          setBtnLoading(false);
        });
      setResLoading(false);
      setBtnLoading(false);
    } else {
      if (searchValue !== "") {
        searchValue = "TXN_" + searchValue;
      }
      if (activePage !== "") {
        setBtnLoading(true);
      } else {
        setResLoading(true);
      }
      await searchTransactions(
        sessionStorage.getItem("email") || "",
        amc_code,
        fund ? fund : fund_code?.length > 0 ? fund_code : "",
        status === "-1" ? "" : status,
        searchValue,
        activePage
      )
        .then((response) => {
          if (response.data.data.length > 0) {
            let pageArr = paginationArr;
            let existingPageIndex = paginationArr.findIndex(
              (x) => x === response.data.page_info.next_page_number
            );
            if (
              existingPageIndex === -1 &&
              response.data.data.length === 10
              // &&
              // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
            ) {
              pageArr.push(response.data.page_info.next_page_number);
            }
            setHasNextPage(response?.data?.page_info?.hasNextPage || false);
            setPaginationArr(pageArr);
            setTransactions(response.data.data);
          } else {
            setTransactions([]);
            setHasNextPage(false);
          }
          setResLoading(false);
          setBtnLoading(false);
        })
        .catch((err) => {
          setHasNextPage(false);
          setResLoading(false);
          setBtnLoading(false);
        });
      setResLoading(false);
      setBtnLoading(false);
    }
  }

  React.useEffect(() => {
    getTransactions();
  }, [activePage]);

  React.useEffect(() => {
    if (sessionStorage.getItem("fund_code")) {
      setFund_code(JSON.parse(sessionStorage.getItem("fund_code") || "[]"));
    } else {
      setFund_code(undefined);
    }
  }, []);

  React.useEffect(() => {
    const handleStorageChange = () => {
      const fundCode = sessionStorage.getItem("fund_code");
      setFund_code(fundCode ? JSON.parse(fundCode) : undefined);
    };

    handleStorageChange();

    window.addEventListener("storage", handleStorageChange);

    return () => {
      window.removeEventListener("storage", handleStorageChange);
    };
  }, []);

  const getFunds = async () => {
    try {
      allFunds.length = 0;
      setAllFunds(allFunds);
      const response = await getFundByAmc(
        email,
        amc_code,
        fund_code?.length > 0 ? fund_code : ""
      );
      setAllFunds(response.data.data);
    } catch (error) { }
  };

  React.useEffect(() => {
    getFunds();
    getTransactions();
  }, [fund_code]);

  // useEffect(() => {

  //   getFunds();
  // }, []);

  // Fund Type Drop Down
  // const renderFundsDropDown = () => {
  //   return allFunds.map((item: any, index) => {
  //     return (
  //       <option key={index} value={item.symbol_code}>
  //         {item.fund_name} - {item.symbol_code}
  //       </option>
  //     );
  //   });
  // };
  const renderFundsDropDown = () => {
    return allFunds.map((item: any, index) => {
      return {
        value: item.symbol_code,
        label: `${item.fund_name} - ${item.symbol_code}`,
      };
    });
  };

  const searchTransactionsByAMCAndFund = async (
    statusVar = "",
    searchVar = "",
    amcCodeVar = "",
    fundCodeVar = ""
  ) => {
    setTogglePagination(true);
    return new Promise(async (resolve, reject) => {
      if (searchVar !== "") {
        searchVar = "TXN_" + searchVar;
      }
      if (activePage !== "") {
        setBtnLoading(true);
      } else {
        setResLoading(true);
      }
      setSearchLoading(true);
      await searchTransactions(
        sessionStorage.getItem("email") || "",
        amc_code,
        fundCodeVar ? fundCodeVar : fund_code?.length > 0 ? fund_code : "",
        statusVar === "-1" ? "" : statusVar,
        searchVar,
        activePage
      )
        .then((response) => {
          if (response.data.data.length > 0) {
            // let pageArr = paginationArr

            paginationArr = paginationArr.filter(function (item) {
              return item == "";
            });
            let pageArr = paginationArr;
            let existingPageIndex = paginationArr.findIndex(
              (x) => x === response.data.page_info.next_page_number
            );
            if (
              existingPageIndex === -1 &&
              response.data.data.length === 10
              // &&
              // 10 * pageArr.length !== parseInt(response.data.page_info.total_count)
            ) {
              pageArr.push(response.data.page_info.next_page_number);
            }
            setHasNextPage(response?.data?.page_info?.hasNextPage || false);
            setPaginationArr(pageArr);
            setTransactions(response.data.data);
          } else {
            setHasNextPage(false);
            setTransactions([]);
          }
          setResLoading(false);
          setBtnLoading(false);
          setSearchLoading(false);

          resolve("Success");
        })
        .catch((err) => {
          setHasNextPage(false);
          setResLoading(false);
          setBtnLoading(false);
          setSearchLoading(false);
          reject("Error");
        });
      setResLoading(false);
      setBtnLoading(false);
      setSearchLoading(false);
    });
  };

  const clearFilters = async (
    statusVar = undefined as any,
    searchVar = undefined as any,
    pageNumber: string = ""
  ) => {
    return new Promise(async (resolve, reject) => {
      // setLoading(true);
      if (activePage !== "") {
        setBtnLoading(true);
      } else {
        setResLoading(true);
      }
      setClearLoading(true);
      await getAllPendingTransactions(
        sessionStorage.getItem("email") || "",
        statusVar === undefined ? status : statusVar,
        searchVar === undefined ? searchValue : searchVar,
        "",
        activePage,
        "",
        fund_code?.length > 0 ? fund_code : "",
        amc_code
      )
        .then((response) => {
          let pageArr = paginationArr;
          let existingPageIndex = paginationArr.findIndex(
            (x) => x === response.data.page_info.next_page_number
          );
          if (
            existingPageIndex === -1 &&
            response.data.data.length === 10 &&
            10 * pageArr.length !==
            parseInt(response.data.page_info.total_count)
          ) {
            pageArr.push(response.data.page_info.next_page_number);
          }
          setHasNextPage(response?.data?.page_info?.hasNextPage || false);
          setPaginationArr(pageArr);
          setTransactions(response.data.data);
          setResLoading(false);
          setBtnLoading(false);
          setClearLoading(false);
          resolve("Success");
          setTogglePagination(false);
        })
        .catch((err) => {
          setHasNextPage(false);
          setResLoading(false);
          setBtnLoading(false);
          setClearLoading(false);
          if (err.response !== undefined) {
            toast.error(err.response.data.message);
          } else {
            toast.error("Request Failed!");
          }
          reject("Error");
        });
      setResLoading(false);
      setBtnLoading(false);
      setClearLoading(false);
    });
  };

  const [bankData, setBankData] = useState<any>([]);
  React.useEffect(() => {
    const fetchBank = async () => {
      try {
        const bankResponse = await getAllBanks(email, "", "", amc_code);
        setBankData(bankResponse.data.data);
      } catch (error) { }
    };
    fetchBank();
  }, []);

  const bankName = (bankcode) => {
    const bankdata = bankData.filter((item: any, index: string) => {
      return item.bank_code === bankcode;
    });
    if (bankdata.length > 0) return bankdata[0].bank_name;
    else return bankcode;
  };

  // const numberWithCommas = (amount: any) => {
  //   return amount.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  // };

  // const [Loading, setLoading] = useState(false);
  const [view, setView] = useState(false);
  const [data, setData] = useState<any>([]);
  const titleCase = (value: string) => {
    let sentence = value.toLowerCase().split("_");
    for (let i = 0; i < sentence.length; i++) {
      sentence[i] = sentence[i][0].toUpperCase() + sentence[i].slice(1);
    }
    return sentence.join(" ");
  };
  const renderData = () => {
    return data.map((value: any, index: number) => {
      return (
        <>
          {value[0] !== "txn_history" && value[0] !== "file" ? (
            <Col md="6" key={index}>
              <div className="input-holder left">
                <p className="label">{titleCase(value[0])}</p>
                <div className="input-1 hide-overflow">
                  <p
                    style={{
                      fontSize: "12px",
                    }}
                  >
                    {typeof value[1] === "string"
                      ? value[0] === "file"
                        ? "N/A"
                        : value[1]
                      : value[0] === "file"
                        ? "N/A"
                        : ""}
                  </p>
                </div>
              </div>
            </Col>
          ) : (
            ""
          )}
        </>
      );
    });
  };

  const [note, setNote] = useState("");

  const viewCheckListPopup = () => {
    switch (viewChecklist) {
      case true:
        return (
          <Modal className="" dialogClassName="modal90w" show={true} size="xl">
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setViewCheckList(false);
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">Approval Check List </h6>
            </div>
            <div className="modal-body">
              <div>
                <div className={"checlist-scroll"}>
                  {trx_checklist.map((val: any, ind: any) => {
                    return (
                      <Row key={ind} className="pt-3">
                        <Col md="4">
                          <text className="text-primary">{val.serial_no}.</text>{" "}
                          <text>{val.message}</text>
                        </Col>
                        <Col md="8">
                          <div className="row">
                            <div className="col-sm-3">
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    checked={val.value == "compliant"}
                                    type="checkbox"
                                    value="compliant"
                                    readOnly
                                  />
                                  <span className="form-check-sign" />
                                  Compliant
                                </Label>
                              </FormGroup>
                            </div>
                            <div className="col-sm-3">
                              <FormGroup check>
                                <Label check>
                                  <Input
                                    type="checkbox"
                                    id="unlisted"
                                    checked={val.value == "na"}
                                    value="na"
                                    readOnly
                                  />
                                  <span className="form-check-sign" />N /A
                                </Label>
                              </FormGroup>
                            </div>
                            <div className="col-sm-6">
                              <div className="form-group">
                                <input
                                  type="text"
                                  placeholder="Comments"
                                  value={val.comment}
                                  className="form-control"
                                  readOnly
                                />
                              </div>
                            </div>
                          </div>
                        </Col>
                      </Row>
                    );
                  })}
                </div>

                {note !== "" && (
                  <Row>
                    <div className="col-md-12">
                      <label>Reason of Reject</label>
                      <div className="form-group">
                        <textarea
                          placeholder="Reason"
                          className={"form-control w-100"}
                          value={note}
                          readOnly
                        ></textarea>
                      </div>
                    </div>
                  </Row>
                )}

                <Row>
                  <Col>
                    <div className=" ">
                      <button
                        className="btn btn-primary mt-3"
                        onClick={() => {
                          setViewCheckList(false);
                        }}
                      >
                        Cancel
                      </button>
                    </div>
                  </Col>
                </Row>
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };
  const renderDataOfTransaction = () => {
    return transactions.map((transaction: any, index: any) => {
      return (
        <tr key={index}>
          <td>{transaction.txn_id}</td>
          <td>{transaction.amc_name ? transaction.amc_name : "N/A"}</td>
          <td>
            {transaction.name_of_beneficiary
              ? transaction.name_of_beneficiary
              : "N/A"}
          </td>
          <td>
            {transaction.type_of_transaction
              ? transaction.type_of_transaction
              : "N/A"}
          </td>
          <td>
            {moment(transaction.txn_history[0].created_at).format("DD-MM-YYYY")}
          </td>
          <td className=" ">
            <div className="multi-icons pointer">
              <img
                src="assets/view.svg"
                alt=""
                width="16"
                onClick={() => {
                  let objArr = Object.entries(transaction);
                  setData(objArr);
                  setView(true);
                }}
              />
            </div>
          </td>
          <td>{transaction.txn_status}</td>
        </tr>
      );
    });
  };
  let [searchValue, setSearchValue] = useState("");
  const renderPsxData = () => {
    return securites.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.type}</td>
          <td>{items.market}</td>
          <td>{items.symbol}</td>
          <td>{items.quantity}</td>
          <td>{items.avg_rate}</td>
          <td>{items.gross_amount}</td>
          <td>{items.deductions}</td>
          <td>{items.additions}</td>
          <td>{items.net_amount}</td>
        </tr>
      );
    });
  };
  const [flagForSecutities, setFlagForSecutities] = useState(false);
  const [securites, setSecurites] = useState<any>([]);
  const renderSecuritiesModalPopup = () => {
    switch (flagForSecutities) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="lg"
            backdrop={true}
            onHide={() => {
              setFlagForSecutities(false);
            }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setFlagForSecutities(false);
                  // clearTaxobject();
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">View Security </h6>
            </div>

            <div className="modal-body">
              <div className="">
                {securites.length > 0 && (
                  <div className="">
                    <table className="table ">
                      <thead>
                        <tr>
                          <th>Type</th>
                          <th>Market</th>
                          <th>Symbol</th>
                          <th>Quantity</th>
                          <th>Avg Rate</th>
                          <th>Gross Amount</th>
                          <th>Deduction</th>
                          <th>Addition</th>
                          <th>Net Amount</th>
                        </tr>
                      </thead>
                      <tbody>{renderPsxData()}</tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };
  //view tax table
  const [viewTaxModal, setTaxModal] = useState(false);
  const [totalTax, setTotalTax] = useState<any>([]);
  //render Tax table data
  const renderTaxData = () => {
    return totalTax.map((items: any, index: number) => {
      return (
        <tr key={index}>
          <td>{items.name}</td>
          <td>{items.amount}</td>
          <td>{items.calculatedAmount}</td>
        </tr>
      );
    });
  };
  const renderTaxPopup = () => {
    switch (viewTaxModal) {
      case true:
        return (
          <Modal
            className=""
            dialogClassName="modal90w"
            show={true}
            size="lg"
            backdrop={true}
            onHide={() => {
              setTaxModal(false);
            }}
          >
            <div className="modal-header ">
              <button
                aria-hidden={true}
                className="close"
                data-dismiss="modal"
                type="button"
                onClick={() => {
                  setTaxModal(false);
                  // clearTaxobject();
                }}
              >
                <i className="tim-icons icon-simple-remove" />
              </button>
              <h6 className="title title-up">View Txn Charges </h6>
            </div>

            <div className="modal-body">
              <div className="">
                {totalTax.length > 0 && (
                  <div className="">
                    <table className="table">
                      <thead>
                        <tr>
                          <th>Tax Name</th>
                          <th>Tax Amount</th>
                          <th>Calculated Amount</th>
                        </tr>
                      </thead>
                      <tbody>{renderTaxData()}</tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
          </Modal>
        );
      default:
        return "";
    }
  };
  // let txnTypes = JSON.parse(sessionStorage.getItem('txnType') || '');
  let txnTypes = useSelector((state: any) => state.txnTypes);
  const CapTxnType = (type: any) => {
    let i, txType;
    for (i = 0; i < txnTypes.length; i++) {
      if (txnTypes[i].api_name === type) {
        txType = txnTypes[i].dis_name;
        break;
      }
    }
    return txType;
  };

  const [viewTxnModal, setViewTxnModal] = useState(false);
  const [viewChildrensListing, setViewChildrensListing] = useState(false);
  const renderViewTxnModalPopup = () => {
    switch (viewTxnModal) {
      case true:
        return (
          <ReusableModal
            show={viewTxnModal}
            onClose={() => {
              setView(false);
              setViewTxnModal(false);
              setViewChildrensListing(false)
            }}
            title={viewChildrensListing ? "View Child Txn Listing" : "View Transaction"}
            data={data}
            trxHistory={trx_history}
            onHistoryClick={(hist) => {
              if (hist.action === "REJECTED-AMC") {
                setNote(hist.note);
              } else {
                setNote("");
              }

              if (hist.action === "CREATED") return;
              if (!hist.check_list) return;

              setTrxCheckList(hist.check_list);
              setViewCheckList(true);
            }}
            viewChildrensListing={viewChildrensListing}
          >
            <ViewTransaction data={data} />
          </ReusableModal>
        );
      default:
        return "";
    }
  };

  const selectedFundName = React.useMemo(() => {
    const selectedFund =
      allFunds && allFunds?.find((item) => item?.symbol_code === fund);
    return selectedFund
      ? {
        value: selectedFund.symbol_code,
        label: `${selectedFund.fund_name} - ${selectedFund.symbol_code}`,
      }
      : null;
  }, [allFunds, fund]);

  const selectedStatus = React.useMemo(() => {
    const selectedFund =
      statusArr && statusArr?.find((item) => item?.value === status);
    return selectedFund
      ? {
        value: selectedFund.value,
        label: selectedFund.label,
      }
      : null;
  }, [statusArr, status]);

  const customStyles = {
    menuPortal: (base) => ({ ...base, zIndex: 9999 }),
    option: (styles, { isFocused, isSelected }) => ({
      ...styles,
      background: isFocused
        ? "hsla(291, 64%, 42%, 0.5)"
        : isSelected
          ? "hsla(291, 64%, 42%, 1)"
          : undefined,
      zIndex: 1,
    }),
    menuList: (styles) => ({
      ...styles,
      background: theme == "dark" ? "#3b3b3b" : "#ffffff",
      color: theme == "dark" ? "white" : "",
    }),
    menu: (base) => ({
      ...base,
      zIndex: 100,
    }),
    control: (base, state) => ({
      ...base,
      background: theme == "dark" ? "#25273a" : "#f2f2f2",
      borderRadius: "0.4285rem",
      borderColor: state.isFocused
        ? "#1d8cf8"
        : theme !== "light"
          ? "#2b3553"
          : "",
      boxShadow: state.isFocused ? null : null,
      "&:hover": {
        borderColor: state.isFocused ? "" : "#ba54f5",
      },
      '& .react-select__input input[type="color"]': {
        color: theme === "dark" ? "red" : "black",
      },
    }),
    singleValue: (provided) => ({
      ...provided,
      color: theme == "dark" ? "white" : "black",
    }),
    input: (base) => ({
      ...base,
      color: theme == "dark" ? "white" : "black",
    }),
  };

  return (
    <>
      <div className="content">
        <Row>
          <Col md="12">
            <Container fluid>
              {/* <Header />	 */}
              {!view ? (
                <div className="card ">
                  <div className="card-header">
                    <h4 className="card-title">Transactions</h4>
                  </div>
                  <div className="card-body">
                    <div className="row align-items-center">
                      <div className="col-md-2">
                        <ReactTooltip
                          textColor="white"
                          backgroundColor="black"
                          effect="float"
                        />
                        <div className="form-group">
                          <label>Transaction ID</label>
                          <input
                            style={{
                              paddingTop: "6px",
                              paddingBottom: "6px",
                            }}
                            type="search"
                            id="myInput"
                            placeholder="Transaction Id"
                            data-tip="Search Transaction"
                            className="form-control"
                            value={searchValue}
                            onChange={(e) => {
                              setSearchValue(e.target.value);
                            }}
                          />
                        </div>
                      </div>

                      <div className="col-md-2">
                        <div className="form-group ml-2 mr-2">
                          <label>Select Fund</label>
                          <Select
                            value={selectedFundName}
                            label={"Select Fund"}
                            onChange={(e) => {
                              setFund(e?.value);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={renderFundsDropDown()}
                            styles={customStyles}
                          />
                          {/* <select
                            className={"form-control"}
                            value={fund}
                            onChange={(e) => {
                              setFund(e.target.value);
                            }}
                          >
                            <option value="" defaultChecked hidden>
                              Select Fund
                            </option>
                            {renderFundsDropDown()}
                          </select> */}
                        </div>
                      </div>

                      <div className="col-md-2 ">
                        <div className="form-group">
                          <label>Select Status</label>
                          <Select
                            value={selectedStatus}
                            label={"Select type"}
                            onChange={(e) => {
                              setStatus(e?.value);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            options={statusArr}
                            styles={customStyles}
                          />
                          {/* <select
                            className="form-control ml-2"
                            onChange={(e) => {
                              setStatus(e.target.value);
                            }}
                            value={status}
                          >
                            <option value="-1">Select type</option>
                            <option value="CREATED">Created</option>
                            <option value="COMPLETED">Completed</option>
                            <option value="REJECTED">Rejected</option>
                            <option value="REJECTED-AMC">Rejected-Amc</option>
                          </select> */}
                        </div>
                      </div>

                      <div className="col-md-4">
                        <div
                          style={{
                            marginTop: "5px"
                          }}
                          className=" inline-box"
                        >
                          <button
                            className="btn btn-primary mt-3 ml-2 py-2"
                            disabled={Boolean(searchLoading)}
                            onClick={() => {
                              if (
                                (searchValue || status !== "-1" || fund) !== ""
                              ) {
                                searchTransactionsByAMCAndFund(
                                  status,
                                  searchValue,
                                  "",
                                  fund
                                ).then(() => {
                                  setActivePage("");
                                });
                              }
                            }}
                          >
                            {searchLoading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Searching...</span>
                              </>
                            ) : (
                              "Search"
                            )}
                          </button>

                          <button
                            className="btn btn-default ml-2 mt-3 ml-2 py-2"
                            disabled={Boolean(clearLoading)}
                            style={{
                              width: "148px",
                            }}
                            onClick={() => {
                              clearFilters("", "").then(() => {
                                // setStatus("-1");
                                setStatus("");
                                setSearchValue("");
                                setActivePage("");
                                setFund("");
                              });
                            }}
                          >
                            {clearLoading ? (
                              <>
                                <span
                                  className="spinner-border login-txt spinner-border-sm"
                                  role="status"
                                  aria-hidden="true"
                                ></span>
                                <span className="login-txt"> Clear</span>
                              </>
                            ) : (
                              "Clear"
                            )}
                          </button>
                        </div>
                      </div>
                    </div>

                    <div className="">
                      {resLoading ? (
                        <div className="d-flex justify-content-center my-5">
                          <i
                            className="fa fa-spinner fa-spin fa-3x"
                            aria-hidden="true"
                          ></i>
                        </div>
                      ) : transactions.length > 0 ? (
                        <TransactionTable
                          transactions={transactions}
                          CapTxnType={CapTxnType}
                          pageName={"pendingTransaction"}
                          bankName={bankName}
                          setTrxHistory={setTrxHistory}
                          setData={setData}
                          setViewTxnModal={setViewTxnModal}
                          setViewChildrensListing={setViewChildrensListing}
                          hasChild={hasChild}
                        />
                      ) : (
                        <div className="table-empty">
                          <BsTable className="icon" />
                          <p className="text-center empty-text">
                            No record found
                          </p>
                        </div>
                      )}
                      <div className="row justify-content-center ">
                        {hasNextPage ? (
                          <button
                            aria-hidden={true}
                            className="btn btn-sm mt-2 py-2 px-3 pointer"
                            disabled={!hasNextPage || resLoading || btnLoading}
                            type="button"
                            onClick={() => {
                              let pageNowIs =
                                Number(activePage == "" ? "1" : activePage) + 1;
                              setActivePage(pageNowIs?.toString());
                            }}
                          >
                            {resLoading || btnLoading ? (
                              <span>
                                Loading...{" "}
                                <i
                                  className="fa fa-spinner fa-spin  "
                                  aria-hidden="true"
                                ></i>
                              </span>
                            ) : (
                              "Show More"
                            )}
                          </button>
                        ) : transactions.length > 20 && !hasNextPage ? (
                          <span className="my-2">No More Record To Show</span>
                        ) : (
                          ""
                        )}
                      </div>
                    </div>
                  </div>
                </div>
              ) : (
                <div className="">
                  <h4 className="card-title">
                    <i
                      className="fa fa-angle-left mr-2 pointer"
                      onClick={() => {
                        setView(false);
                      }}
                    ></i>
                    View Transaction
                  </h4>
                  <ViewTransaction data={data} />

                  <div className="line"></div>

                  <Row className=" pb-5">
                    {trx_history.map((hist: any, index: number) => {
                      return (
                        <Col
                          md="3"
                          onClick={() => {
                            if (hist.action === "REJECTED-AMC") {
                              setNote(hist.note);
                            } else {
                              setNote("");
                            }
                            if (hist.action === "CREATED") {
                              return;
                            }
                            if (!hist.check_list) return;
                            setTrxCheckList(hist.check_list);
                            setViewCheckList(true);
                          }}
                        >
                          <div className="card process-card pointer">
                            <div className="card-header">
                              <h4 className="card-title">
                                <i className="tim-icons icon-single-02 mr-1"></i>{" "}
                                <span className="card-number">{index + 1}</span>
                                {hist.updated_by_role}{" "}
                              </h4>
                            </div>
                            <div className="card-body text-center">
                              <p className="small mt-2">Status:</p>
                              <h3 className="accepted text-primary">
                                {" "}
                                {hist.action}{" "}
                              </h3>
                              {hist.updated_at !== "" ? (
                                <>
                                  <p className="small mt-2">by</p>
                                  <h4 className="comment text-primary">
                                    {hist.updated_by}
                                  </h4>
                                  <p className="small mt-2">at</p>
                                  <h4 className="comment text-primary">
                                    {moment(hist.updated_at).format(
                                      "DD-MM-YYYY, h:mm a"
                                    )}
                                  </h4>
                                </>
                              ) : (
                                ""
                              )}
                              {hist.note !== "" ? (
                                <>
                                  <p className="small mt-2">Comment</p>
                                  <small
                                    className="comment dot-text"
                                    title={hist.note}
                                  >
                                    {hist.note}
                                  </small>
                                </>
                              ) : (
                                ""
                              )}
                              {hist.created_by !== "" ? (
                                <>
                                  <p className="small mt-2">by</p>
                                  <h4 className="text-primary">
                                    {hist.created_by}
                                  </h4>
                                  <p className="small mt-2"> at</p>
                                  <h4 className="comment text-primary">
                                    {" "}
                                    {moment(hist.created_at).format(
                                      "DD-MM-YYYY, h:mm a"
                                    )}{" "}
                                  </h4>
                                </>
                              ) : (
                                ""
                              )}
                            </div>
                          </div>
                        </Col>
                      );
                    })}
                  </Row>
                </div>
              )}
              {viewCheckListPopup()}
              {renderSecuritiesModalPopup()}
              {renderTaxPopup()}
              {renderViewTxnModalPopup()}
            </Container>
          </Col>
        </Row>
      </div>
    </>
  );
};
export default PendingTransactions;
